import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import Modalizer from 'components/modalizer/modalizer'
import Iframe from 'components/iframe/iframe'

import styles from './ql_collaborate_create_modal_view.scss'

class QuickLaunchCollaborateCreateModal extends PureComponent {

	render() {
		return (
			<Modalizer
				width='800px'
				closeAction={this.props.closeModalHandler}
			>
				<div styleName='wrapper'>
					{ this.props.collaborateUrl &&
						<Iframe
							src={this.props.collaborateUrl}
						/>
					}
				</div>
			</Modalizer>
		)
	}
}

QuickLaunchCollaborateCreateModal.propTypes = {
	closeModalHandler: PropTypes.func,
	collaborateUrl: PropTypes.string.isRequired,
}

QuickLaunchCollaborateCreateModal.defaultProps = {
	closeModalHandler: () => {},
}

export default CSSModules(
	QuickLaunchCollaborateCreateModal,
	styles,
	{allowMultiple: true},
)
